<div class="voucher-redemption-page">
  <ng-container>
    <app-hero-banner
      id="beyond-voucher-redemption"
      [name]="'VOUCHER_REDEMPTION.TITLE' | translate"
      [title]="
        currentUser
          ? ('VOUCHER_REDEMPTION.HERO.TITLE' | translate)
          : ('VOUCHER_REDEMPTION.HERO.TITLE_NOT_SIGNED_IN' | translate)
      "
      [heroImageCss]="'course-hero'"
      [alignContentCss]="['text-color-white']"
      [gradientOverlayCss]="'gradient-overlay'"
      [showButton]="showHeroBannerButton"
      [routeType]="'internal'"
      [route]="'login'"
      [actionLabel]="cardTypeCallToActions.SIGN_IN"
      [description]="
        currentUser
          ? ('VOUCHER_REDEMPTION.HERO.DESCRIPTION' | translate)
          : ('VOUCHER_REDEMPTION.HERO.SIGN_IN_MESSAGE' | translate : signInParams)
      ">
    </app-hero-banner>

    <div class="wrapper" *ngIf="currentUser">
      <div class="columns">
        <div class="full-width">
          <!--STEP COMPONENT-->
          <app-steps [steps]="steps" [isMobile]="isMobile"></app-steps>
          <!--END STEP COMPONENT-->
          <div class="voucher-redemption margin-top-large" *ngIf="!firstStep && !secondStep">
            <!--TODO: Need to revisit once we have the webservice in place-->

            <div class="verify-voucher" [ngClass]="{ 'sign-in': !currentUser }">
              <div *ngIf="showVoucherCodeError" class="voucher-error">
                <!--ERROR MESSAGE RESPONSE-->
                <!-- NOTE: See defaultErrorMessage shared outlet below page-->
                <ng-template
                  [ngTemplateOutlet]="defaultErrorMessage"
                  [ngTemplateOutletContext]="{ errorResponse: voucherErrorResponse }"></ng-template>
                <!--END ERROR MESSAGE RESPONSE-->
              </div>
              <!--STEP 1-->
              <ng-container *ngTemplateOutlet="step1"></ng-container>
            </div>
          </div>
          <!--VOUCHER ACTIVATION-->
          <div class="activate-voucher" *ngIf="firstStep">
            <div *ngIf="showVoucherActivateError" class="voucher-error">
              <!--ERROR MESSAGE RESPONSE-->
              <!-- NOTE: See defaultErrorMessage shared outlet below page-->
              <ng-template
                [ngTemplateOutlet]="defaultErrorMessage"
                [ngTemplateOutletContext]="{
                  errorResponse: voucherRedeemErrorResponse
                }"></ng-template>
              <!--END ERROR MESSAGE RESPONSE-->
            </div>
            <ng-container *ngTemplateOutlet="step2"></ng-container>
          </div>
          <!--END VOUCHER ACTIVATION-->
          <!--END SUBSCRIPTION ACTIVATED-->
          <div class="voucher-activated margin-top-large" *ngIf="secondStep">
            <ng-container *ngTemplateOutlet="step3"></ng-container>
          </div>
        </div>
      </div>
      <!--SUBSCRIPTION ACTIVATED-->
    </div>
  </ng-container>
</div>
<!--EXPLORE CATALOG-->
<div class="explore-catalog" *ngIf="shouldShowExploreSection">
  <div class="wrapper">
    <h1 class="brand margin-bottom-large">{{ 'VOUCHER_REDEMPTION.EXPLORE.TITLE' | translate }}</h1>
    <p class="medium margin-top-large">
      {{ 'VOUCHER_REDEMPTION.EXPLORE.DESCRIPTION' | translate }}
    </p>
    <div class="margin-top-small action-button">
      <a
        routerLink="/search"
        routerLinkActive="active"
        class="btn btn-primary larger-btn padding-right-small">
        {{ 'VOUCHER_REDEMPTION.EXPLORE.VIEW_CATALOG' | translate }}
      </a>
    </div>
  </div>
</div>
<!--END EXPLORE CATALOG-->

<!-- COMMON ERROR MESSAGE RESPONSE TEMPLATE-->
<!-- NOTE: let-<variable> is the parameters that passed to the template. if you need to add any other various uses the let-<variable> and map
    the variable here and pass throught the ngTemplateOutlet the values -->
<ng-template #defaultErrorMessage let-errorResponse="errorResponse">
  <div class="errorMessage" *ngIf="errorResponse">
    <i class="icon red x-small warning"></i>
    <p>
      {{ errorResponse }}
      <br />
      Please contact
      <a class="gen-primary-link--accesible with-underline" href="mailto:beyond@genesys.com"
        >beyond&#64;genesys.com</a
      >
    </p>
  </div>
</ng-template>

<ng-template #step1>
  <ng-container *ngIf="currentUser">
    <div class="awaiting-activation">
      <h4>{{ 'VOUCHER_REDEMPTION.STEPS.TITLE' | translate }}</h4>
      <br />
      <p class="margin-bottom-small">
        {{ 'VOUCHER_REDEMPTION.STEPS.ENTER_CODE_TEXT' | translate }}
      </p>
      <div class="voucher-filter">
        <p>{{ 'VOUCHER_REDEMPTION.STEPS.ENTER_CODE' | translate }}</p>
        <form [formGroup]="voucherLookupForm" (ngSubmit)="onVoucherSubmission()">
          <div class="voucher-box-container">
            <input
              id="voucher-code"
              type="text"
              class="margin-top-small"
              (ngModelChange)="onChange($event)"
              [ngClass]="{ 'is-invalid': showVoucherCodeError }"
              formControlName="voucherCode" />
            <input
              type="submit"
              class="btn btn-primary margin-top-small"
              [disabled]="!isVoucherCode"
              value="{{ 'VOUCHER_REDEMPTION.STEPS.VALIDATE' | translate }}" />
          </div>
        </form>
        <div class="margin-top-large">
          <div *ngIf="showVoucherCodeError" class="voucher-error">
            <!--ERROR MESSAGE RESPONSE-->
            <!-- NOTE: See defaultErrorMessage shared outlet below page-->
            <ng-template
              [ngTemplateOutlet]="defaultErrorMessage"
              [ngTemplateOutletContext]="{ errorResponse: showErrMsg }"></ng-template>
            <!--END ERROR MESSAGE RESPONSE-->
          </div>
          <p class="vcode-details margin-bottom-small">
            <u class="margin-right-small">{{
              'VOUCHER_REDEMPTION.STEPS.WHERE_FIND' | translate
            }}</u>
            <app-information-tooltip
              [tooltipData]="'VOUCHER_REDEMPTION.STEPS.TOOLTIP' | translate"
              [tooltipIcon]="'info-icon'"
              [iconSize]="'x-smallest'"
              [iconColor]="'red'">
            </app-information-tooltip>
          </p>
        </div>
        <ng-template [ngIf]="isLoading">
          <app-loading-spinner></app-loading-spinner>
        </ng-template>
      </div>
    </div>
    <br />
  </ng-container>
</ng-template>

<ng-template #step2>
  <div class="step2">
    <h4>{{ 'VOUCHER_REDEMPTION.STEPS.BEFORE_ACTIVATE_TITLE' | translate }}</h4>
    <p>
      {{ 'VOUCHER_REDEMPTION.STEPS.BEFORE_ACTIVATE' | translate }}
    </p>
    <br />
    <h4>{{ 'VOUCHER_REDEMPTION.STEPS.VOUCHER_CODE_TITLE' | translate }}</h4>
    <p>
      {{ 'VOUCHER_REDEMPTION.STEPS.VALID_FOR' | translate }} <strong>{{ productName }}</strong
      >.
    </p>
    <br />
    <p [innerHTML]="'VOUCHER_REDEMPTION.STEPS.CONFIRMATION_TEXT' | translate"></p>
    <div class="activate-subscription margin-top-small">
      <button (click)="redeemVoucher()" [disabled]="disableActivateButton" class="btn btn-primary">
        {{ 'VOUCHER_REDEMPTION.STEPS.ACTIVATE' | translate }}
      </button>
    </div>
    <ng-template [ngIf]="isLoading">
      <app-loading-spinner></app-loading-spinner>
    </ng-template>
    <div *ngIf="showVoucherActivateError" class="voucher-error">
      <!--ERROR MESSAGE RESPONSE-->
      <!-- NOTE: See defaultErrorMessage shared outlet below page-->
      <ng-template
        [ngTemplateOutlet]="defaultErrorMessage"
        [ngTemplateOutletContext]="{ errorResponse: showErrMsg }"></ng-template>
      <!--END ERROR MESSAGE RESPONSE-->
    </div>
    <p
      class="email-beyond margin-top-small"
      [innerHTML]="'VOUCHER_REDEMPTION.STEPS.EMAIL_SUPPORT' | translate : signInParams"></p>
  </div>
</ng-template>

<ng-template #step3>
  <div class="activation-steps padding-left-small padding-right-small padding-bottom-large">
    <div class="text-align-center">
      <p class="padding-top-large">
        <strong>{{ 'VOUCHER_REDEMPTION.SUCCESS' | translate }}</strong>
      </p>
      <p class="padding-top-small">{{ 'VOUCHER_REDEMPTION.EMAIL_CHECK' | translate }}</p>
      <p
        class="padding-top-small"
        *ngIf="
          productId === subscriptionProductIds.AGENT_PLATFORM_AP_TRAINING_FOR_GENESYS_CLOUD ||
          productId === subscriptionProductIds.PARTNER_RESELL_AGENT_PLATFORM_AP_SUBSCRIPTION
        "
        [innerHTML]="'VOUCHER_REDEMPTION.GET_STARTED' | translate"></p>
    </div>
    <ng-container
      *ngIf="
        productId !== subscriptionProductIds.AGENT_PLATFORM_AP_TRAINING_FOR_GENESYS_CLOUD &&
        productId !== subscriptionProductIds.PARTNER_RESELL_AGENT_PLATFORM_AP_SUBSCRIPTION
      ">
      <ng-container
        *ngIf="
          productId === subscriptionProductIds.TECHNICAL_LEARNING_SUBSCRIPTION_AI;
          else recommended
        ">
        <app-learning-plan-tiles></app-learning-plan-tiles>
      </ng-container>
      <ng-template #recommended>
        <app-recommended-foundational-courses
          [actionButtonCss]="actionButtonCss"
          title="Begin with a Solid Foundation"
          description="{{
            'Here are some recommended foundational courses to become a ' +
              validateResponse?.productName +
              ' Professional.'
          }}"
          [selectedSubscription]="selectedSubscription?.shortcutName"
          [queryParams]="getSearchQuery(selectedSubscriptionUIConfiguration?.subscriptionType)"
          [courseIds]="selectedSubscriptionUIConfiguration?.courseIds"
          (sendClick)="sendGoogleAnalytics('Subscription Detail', 'click', 'View All Courses')"
          [selectedSubscriptionSlug]="selectedSubscription?.slugName">
        </app-recommended-foundational-courses>
      </ng-template>
    </ng-container>
  </div>
</ng-template>

<app-modal-dialog [containerID]="'voucherModal'" [modalMaxWidth]="'modal-max-width-medium'">
  <div #modalContainer>
    <p>
      Do you want to leave the voucher redemption activation step? Leaving this page will not
      activate the Voucher.
    </p>
    <div class="margin-top-small">
      <button class="btn btn-primary btn-small" (click)="reset()">OK</button>
      <button class="btn btn-inverse-gray btn-small margin-left-small" (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
</app-modal-dialog>
